var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-4"},[_c('p',{staticClass:"text-center"},[_vm._v("The page for which you are looking appears to have been washed away.")])])
}]

export { render, staticRenderFns }